module.exports = "/_next/static/images/rob-d27d4b09886368266a0ca9b08b1645ae.jpg";